module.exports = __webpack_public_path__ + "static/img/1.426e1f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/1.png
// module id = E49l
// module chunks = 0